export default {
  today: 'TÃ¤na',
  now: 'Praegu',
  backToToday: 'Tagasi tÃ¤nase juurde',
  ok: 'Ok',
  clear: 'TÃ¼hista',
  month: 'Kuu',
  year: 'Aasta',
  timeSelect: 'Vali aeg',
  dateSelect: 'Vali kuupÃ¤ev',
  monthSelect: 'Vali kuu',
  yearSelect: 'Vali aasta',
  decadeSelect: 'Vali dekaad',
  yearFormat: 'YYYY',
  dateFormat: 'D.M.YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D.M.YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Eelmine kuu (PageUp)',
  nextMonth: 'JÃ¤rgmine kuu (PageDown)',
  previousYear: 'Eelmine aasta (Control + left)',
  nextYear: 'JÃ¤rgmine aasta (Control + right)',
  previousDecade: 'Eelmine dekaad',
  nextDecade: 'JÃ¤rgmine dekaad',
  previousCentury: 'Eelmine sajand',
  nextCentury: 'JÃ¤rgmine sajand',
};
